import {
  Target,
  Shield,
  ClipboardCheck,
  FileCode,
  Cpu,
  Package,
  FolderKanban,
  DollarSign,
  Scale,
  BookOpen,
  Link2,
  ShieldCheck,
  FileLock2,
} from 'lucide-react'
import type { ShellModule } from './types'

export const shellModules: ShellModule[] = [
  {
    id: 'softwareiq',
    name: 'SoftwareIQ',
    icon: Cpu,
    href: '/softwareiq',
    description: 'Software assurance & vulnerability management',
    items: [
      { name: 'Workflow', href: '/softwareiq/assurance/workflow', icon: Target },
      { name: 'Findings', href: '/softwareiq/assurance/findings', icon: Shield },
      { name: 'Vetting Queue', href: '/softwareiq/assurance/vetting', icon: ClipboardCheck },
      { name: 'Schemas', href: '/softwareiq/assurance/schemas', icon: FileCode },
    ],
  },
  {
    id: 'complyiq',
    name: 'ComplyIQ',
    icon: Scale,
    href: '/complyiq',
    description: 'Compliance management & audit tracking',
    items: [
      { name: 'eMASSist', href: '/complyiq/emassist', icon: ShieldCheck },
      { name: 'SSP Redactor', href: '/complyiq/ssp-redactor', icon: FileLock2 },
      { name: 'Controls', href: '/complyiq/compliance/controls', icon: Shield },
      { name: 'Assessments', href: '/complyiq/compliance/assessments', icon: ClipboardCheck },
      { name: 'Evidence', href: '/complyiq/compliance/evidence', icon: FileCode },
      { name: 'Audits', href: '/complyiq/audit/audits', icon: BookOpen, separator: true },
      { name: 'Audit Findings', href: '/complyiq/audit/findings', icon: Shield },
    ],
  },
  {
    id: 'metadataiq',
    name: 'MetadataIQ',
    icon: BookOpen,
    href: '/metadataiq/processes',
    description: 'Schema and process governance',
    items: [
      { name: 'Process Definitions', href: '/metadataiq/processes', icon: FileCode },
      { name: 'Integrations', href: '/metadataiq/integrations', icon: Link2 },
    ],
  },
  {
    id: 'supplyiq',
    name: 'SupplyIQ',
    icon: Package,
    href: '/supplyiq',
    description: 'Supply chain risk management',
    comingSoon: true,
    items: [],
  },
  {
    id: 'projectiq',
    name: 'ProjectIQ',
    icon: FolderKanban,
    href: '/projectiq',
    description: 'Project & portfolio management',
    comingSoon: true,
    items: [],
  },
  {
    id: 'financialiq',
    name: 'FinancialIQ',
    icon: DollarSign,
    href: '/financialiq',
    description: 'Financial analytics & reporting',
    comingSoon: true,
    items: [],
  },
]

export const activeModules = shellModules.filter(m => !m.comingSoon)

export const DEFAULT_EXPANDED_MODULES = ['softwareiq']
